import { MMButton } from '@components'
import { useOnboardingAction } from '@hooks'
import cn from '@integrations/classnames'
import { useMerchantQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import styles from './AccountWarning.module.scss'
import WarningHeader from './WarningHeader'

function AccountWarning() {
  const { merchant } = useMerchantQry()
  const { onboardingAction, startOrContinueOnboarding } = useOnboardingAction()

  switch (onboardingAction) {
    case 'NOT_STARTED':
    case 'ONBOARDING':
    case 'DOCUMENTS':
    case 'QUESTIONNAIRE':
    case 'APPLICATION_FEE':
      return (
        <div className={cn(styles['account-warning-wrapper'], 'account-warning-wrapper')}>
          <WarningHeader />
          <div className={cn('mb-2')}>
            {tr(
              'FRONTEND.BANKING.COMMON.ACCOUNT_NOT_STARTED',
              'Complete your account verification to get access to all features and increased payment limits.'
            )}
          </div>
          <MMButton
            type='button'
            variant='alternative'
            caption={tr('FRONTEND.BANKING.COMMON.PROCEED_BUTTON', 'Click here to proceed')}
            onClick={startOrContinueOnboarding}
            fullWidth
            data-test='proceed-button'
          />
        </div>
      )

    case 'UNDER_REVIEW':
      return (
        <div className={cn(styles['account-warning-wrapper'], 'account-warning-wrapper')}>
          <WarningHeader />
          <div>{tr('FRONTEND.BANKING.COMMON.ACCOUNT_UNDER_REVIEW', 'Your account verification is under review.')}</div>
        </div>
      )

    default:
      if (merchant?.onboardingStatus === 'REJECTED_FINAL') {
        return (
          <div className={cn(styles['account-warning-wrapper'], 'account-warning-wrapper')}>
            <WarningHeader />
            <div>
              {tr(
                'FRONTEND.BANKING.COMMON.ACCOUNT_REJECTED',
                'Please contact Customer Service to get support on your account verification.'
              )}
            </div>
          </div>
        )
      }
  }

  return null
}

export default AccountWarning
